import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { ArrowLeftOnRectangleIcon } from '@heroicons/react/24/outline';
import AdminSidebar from '../components/admin/AdminSidebar';
import AdminTopNav from '../components/admin/AdminTopNav';
import { getAdminActiveItem } from '../components/admin/adminNavigation';
import { NotificationBell } from '../components/layout/NotificationBell';
import TotpNudgeCard from '../components/common/TotpNudgeCard';
import { useAuth } from '../contexts/AuthContext';

const AdminLayout: React.FC = () => {
  const location = useLocation();
  const activeItem = getAdminActiveItem(location.pathname);
  const { currentUser } = useAuth();
  const showNotificationBell = Boolean(currentUser);
  return (
    <div className="flex min-h-screen bg-primary-dark-100 text-primary-light-100">
      <AdminSidebar />

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <header className="sticky top-0 z-40 hidden border-b border-primary-dark-300/24 bg-primary-dark-200/88 px-4 py-2.5 backdrop-blur-sm md:flex md:items-center md:justify-between lg:px-6">
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-[0.12em] text-primary-light-400">Admin</p>
            <h1 className="truncate text-base font-semibold text-primary-light-100">
              {activeItem.label}
            </h1>
          </div>
          <div className="flex items-center gap-2">
            {showNotificationBell && <NotificationBell />}
            <Link
              to="/"
              className="inline-flex items-center gap-1 rounded-lg border border-primary-dark-300 px-2 py-1.5 text-xs font-medium text-primary-light-300 hover:border-primary-dark-200 hover:text-primary-light-100"
            >
              <ArrowLeftOnRectangleIcon className="h-4 w-4" />
              Wyjdź
            </Link>
          </div>
        </header>

        <header className="sticky top-0 z-40 border-b border-primary-dark-300/24 bg-primary-dark-200/88 px-2.5 backdrop-blur-sm md:hidden">
          <div className="pt-[max(env(safe-area-inset-top),0px)]">
            <div className="flex h-[3.25rem] items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="text-[11px] uppercase tracking-[0.12em] text-primary-light-400">
                  Admin
                </p>
                <h1 className="truncate text-sm font-semibold text-primary-light-100">
                  {activeItem.label}
                </h1>
              </div>
              <div className="flex items-center gap-1">
                {showNotificationBell && <NotificationBell />}
                <Link
                  to="/"
                  className="inline-flex items-center gap-1 rounded-lg border border-primary-dark-300 px-2 py-1.5 text-xs font-medium text-primary-light-300 hover:border-primary-dark-200 hover:text-primary-light-100"
                >
                  <ArrowLeftOnRectangleIcon className="h-4 w-4" />
                  Wyjdź
                </Link>
              </div>
            </div>
          </div>
        </header>
        <main className="flex-1 overflow-x-hidden overflow-y-auto px-2.5 pb-[calc(6.25rem+env(safe-area-inset-bottom))] pt-3 sm:px-3 md:px-5 md:py-5 md:pb-6 lg:px-6">
          <div className="mx-auto w-full max-w-7xl space-y-3 md:space-y-4">
            {currentUser?.uid && <TotpNudgeCard placement="shell" />}
            <Outlet />
          </div>
        </main>
        <AdminTopNav />
      </div>
    </div>
  );
};

export default AdminLayout;
